import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// local imports
import successImage from 'assets/images/success-image.svg'
import DateUtil from 'utils/DateUtil'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import NotificationDialog from 'components/ui/NotificationDialog'
import useGetLactationRoomList from 'components/home/on-campus-services/lactation-room/hooks/use-get-lactation-room-list'
import ReservationModalWrapper from 'components/home/on-campus-services/lactation-room/reservation-scheduler/ReservationModal'
import LoadingWrapper from './LoadingWrapper'

/* filtered date - default */
const today = DateUtil.getStartOfDay(new Date())
interface CompProps {
  locationId: number
  id: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function LactationRes({ locationId, id, setReservationType }: CompProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const openModal = () => setModal(true)
  const closeModal = (resetRes = false) => {
    setModal(false)
    if (resetRes) setReservationType(0, undefined)()
  }
  const closeNotification = () => {
    setNotification(false)
    setReservationType(0, undefined)()
  }

  /* Get Lactation List */
  const { getLactationRoomList, lactationRooms, loading } = useGetLactationRoomList()
  const selectedRoom = lactationRooms.find((r) => r.id === id)
  useEffect(() => {
    getLactationRoomList({ locationIds: [locationId], reservationDate: today })
    openModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])

  if (loading) return <LoadingWrapper />

  return (
    <>
      {/* Lactation Room Reservation Scheduler Modal */}
      {!!selectedRoom ? (
        <ReservationModalWrapper
          open={modal}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          selectedRoom={selectedRoom}
          filterDate={today}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('lactation-res-modal.notification-title')}
        content={t('lactation-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
